
export default {
  name: 'HomeViewBannerCenterBannerDynamicItemMain',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      videoEl: null,
      target: null,
      isLoaded: false,
      isFailure: false,
    };
  },
  head() {
    return {
      style: [
        {
          cssText: this.item?.content?.style,
          type: 'text/css',
        },
      ],
      link: [
        ...(
          this.needToPreloadImage ? [{
            // hid: this.item?.background?.banner,
            rel: 'preload',
            as: 'image',
            href: this.item?.background?.banner,
          }] : []
        ),
      ],
    };
  },
  mounted() {
    const videoEl = this.$refs.htmlContent && this.$refs.htmlContent.querySelector('video');

    if (videoEl) {
      this.handleCanplay({
        target: videoEl,
      });

      if (this.isLoaded) {
        return;
      }

      const sources = videoEl.querySelectorAll('source');

      const target = (sources.length > 0)
        ? sources[sources.length - 1]
        : videoEl;

      videoEl.addEventListener('canplaythrough', this.handleCanplay);
      target.addEventListener('error', this.handleError);

      this.videoEl = videoEl;
      this.target = target;
    }
  },
  beforeDestroy() {
    if (this.target) {
      this.videoEl.removeEventListener('canplaythrough', this.handleCanplay);
      this.target.removeEventListener('error', this.handleError);
    }
  },
  computed: {
    posterIsAvailable() {
      if (this.needToPreloadImage && this.$isSpider) {
        return true;
      }

      if (this.isFailure) {
        return true;
      }

      return this.needToPreloadImage && !this.isLoaded;
    },
    videoIsAvailable() {
      if (this.$isSpider) {
        return false;
      }

      return this.item?.background?.video && !this.isFailure;
    },
    videoIsShown() {
      return this.videoIsAvailable && this.isLoaded;
    },
    needToPreloadImage() {
      return this.item?.background?.banner;
    },
  },
  methods: {
    handleCanplay(e) {
      if (e.target.readyState >= 3) {
        this.isLoaded = true;
      }
    },
    handleError() {
      this.isFailure = true;
    },
  },
};
